import Typography from "@shared/v2/Typography";
import Button from "@shared/v2/Button";
import formatPhoneNumber from "@shared/FormatPhoneNumber";
import TextLink from "@shared/v2/TextLink";
import TextButton from "@shared/v2/TextButton";
import { useCurrentUser } from "../../../reducers/layoutReducer/selectors";

export interface WaitingForAgentPickupProps {
  agentPhoneNumber?: string;
  onEndSession?: () => void;
  endSessionLoading?: boolean;
}

const WaitingForAgentPickup = ({
  agentPhoneNumber,
  onEndSession,
  endSessionLoading = false,
}: WaitingForAgentPickupProps) => {
  const currentUser = useCurrentUser() as { routingNumber?: string; managedNumber?: string } | undefined;
  const callingNumber = agentPhoneNumber || currentUser?.routingNumber;

  return (
    <div
      data-testid="waiting-for-agent-pickup"
      className="tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-[8px] tw-text-center tw-gap-[32px] tw-h-full"
    >
      <div className="tw-flex-1 tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-[48px]">
        <div className="tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-[8px]">
          {/* @ts-expect-error Typography props */}
          <Typography variant="headline3" className="!tw-text-gray-50">
            {callingNumber ? `Calling you at ${formatPhoneNumber(callingNumber)}` : "Calling your phone"}
          </Typography>
          {/* @ts-expect-error Typography props */}
          <Typography variant="headline1">
            Answer your phone <br /> to connect to the Brivity Dialer
          </Typography>
          {/* @ts-expect-error Typography props */}
          <Typography variant="body-m" className="!tw-text-gray-50">
            Your dialer session will automatically load once you pick up your phone.
          </Typography>
        </div>
        <div className="tw-relative">
          <img src="/images/pick-up-your-phone.png" alt="Pick up your phone" className="tw-max-w-[322px]" />
          <span className="tw-w-full tw-absolute tw-left-0 tw-top-[60px] tw-text-white tw-font-semibold tw-text-24d">
            {currentUser?.managedNumber ? formatPhoneNumber(currentUser.managedNumber) : ""}
          </span>
        </div>
        <div className="tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-[4px]">
          {/* @ts-expect-error Typography props */}
          <Typography variant="body-m" className="!tw-text-gray-50">
            Need help connecting?
          </Typography>
          {/* @ts-expect-error Typography props */}
          <TextLink
            className="tw-font-semibold"
            size="medium"
            href="https://www.brivityknowledge.com/docs/troubleshooting-issues-with-your-brivity-number"
            target="_blank"
          >
            Troubleshoot
          </TextLink>
          {/* @ts-expect-error Typography props */}
          <TextButton
            className="tw-text-14d tw-font-semibold tw-normal-case"
            onClick={() => {
              window.Intercom?.("show");
            }}
          >
            Get Help
          </TextButton>
        </div>
      </div>

      {onEndSession && (
        <div className="tw-w-full tw-flex tw-justify-start">
          {/* @ts-expect-error Typography props */}
          <Button schema="tertiary" onClick={onEndSession} isLoading={endSessionLoading} size="medium">
            Cancel
          </Button>
        </div>
      )}
    </div>
  );
};

export default WaitingForAgentPickup;
